/* eslint-disable no-restricted-syntax */
// @mui material components
import {
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Card,
  Divider,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Icon,
  Container,
  LinearProgress,
  Autocomplete,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
} from "@mui/material";

import { useEffect, useState } from "react";
import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

import { useNavigate } from "react-router-dom";
import { useGeolocated } from "react-geolocated";
import QRCode from "react-qr-code";

import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
import FormSectionBuilder from "app/components/data_forms/form_section_builder";
import GoogleAddressField from "app/components/google_address";
import WarningIcon from "assets/images/icons/custom/warning.png";

import PushNotificationMgr from "app/components/push_notification_mgr";

function SellProduct() {
  const pageTitle = "Sell Product";
  usePageTitle(pageTitle);

  // const [controller] = useMaterialUIController();
  // const { darkMode } = controller;

  const navigate = useNavigate();

  function emptyCache() {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }

  function versionRefresh() {
    emptyCache();
    window.location.reload();
  }

  function appVersionCheck(newVersion) {
    // Handle App Update
    const currentVersion = localStorage.getItem(AppConfig.app_version_store);
    let shouldUpdate = false;
    if (currentVersion !== newVersion) {
      shouldUpdate = true;
    }
    localStorage.setItem(AppConfig.app_version_store, newVersion);

    if (shouldUpdate) {
      if (
        window.confirm(
          "A new version is available. App will automatically refresh to get the latest update."
        ) === true
      ) {
        versionRefresh();
      } else {
        versionRefresh();
      }
    }
  }

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setShowLoading(false);
    setSeverity("error");
  };

  const [campaignUnavailableDialog, setCampaignUnavailableDialog] =
    useState(false);

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  // const [network, setNetwork] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [campaignPaymentMethods, setCampaignPaymentMethods] = useState([]);
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [shippingRequired, setShippingRequired] = useState(false);
  const [selectedCampaignProducts, setSelectedCampaignProducts] = useState([]);
  // const [selectCampaignProduct, setSelectCampaignProduct] = useState(null);
  const [campaignProductVariants, setCampaignProductVariants] = useState([]);
  const [selectCampaignProductVariants, setSelectCampaignProductVariants] =
    useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [sellResult, setSellResult] = useState(null);

  const [showInlineLoading, setShowInlineLoading] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [dataForm, setDataForm] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);

  // const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [productIndex, setActiveStep] = useState(0);
  const [productImageSize, setProductImageSize] = useState(0);

  const [selectedProductObject, setSelectedProductObject] = useState(null);
  const [showProductDialog, setShowProductDialog] = useState(false);
  const [checkoutProducts, setCheckoutProducts] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedProductAmount, setSelectedProductAmount] = useState(0);

  const [shippingRate, setShippingRate] = useState(null);
  const [shippingStates, setShippingStates] = useState([]);
  const [shippingStateOptions, setShippingStateOptions] = useState([]);
  const [selectedShippingState, setSelectedShippingState] = useState(null);
  const [selectedShippingStateOption, setSelectedShippingStateOption] =
    useState(null);

  const [loadedCampaign, setLoadedCampaign] = useState(null);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  const [shippingRecipientName, setShippingRecipientName] = useState(null);
  const [shippingRecipientPhoneNumber, setShippingRecipientPhoneNumber] =
    useState(null);
  const [shippingCity, setShippingCity] = useState(null);
  const [shippingState, setShippingState] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [shippingLatitude, setShippingLatitude] = useState(null);
  const [shippingLongitude, setShippingLongitude] = useState(null);

  const [customerPool, setCustomerPool] = useState(null);
  const [customerPoolValue, setCustomerPoolValue] = useState(null);

  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(stringtext) {
    try {
      await navigator.clipboard.writeText(stringtext);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  useEffect(() => {
    setDataForm(null);
    setShippingRate(null);
    setSelectedShippingState(null);
    setSelectedShippingStateOption(null);
    setShippingStates([]);
    setShippingStateOptions([]);
    setShippingAddress(null);
    setShippingLatitude(null);
    setShippingLongitude(null);
    setShippingCity(null);
    setShippingState(null);
    setShippingRecipientName(null);
    setShippingRecipientPhoneNumber(null);

    setCustomerPoolValue(null);
    setCustomerPool(null);
    setCheckoutProducts([]);
    if (loadedCampaign === null) {
      return;
    }

    setCurrency(loadedCampaign.currency);
    setCampaignPaymentMethods(loadedCampaign.payment_methods);
    setSelectedCampaignProducts(loadedCampaign.products);
    if (loadedCampaign.payment_required) {
      setShowPaymentMethods(true);
    } else {
      setShowPaymentMethods(false);
      setPaymentMethod("FREE");
    }

    if (loadedCampaign.data_form !== null) {
      setDataForm(loadedCampaign.data_form);
    }

    setShippingRequired(loadedCampaign.is_shipping_required);

    if (loadedCampaign.shipping_rate !== null) {
      const states = [];
      for (const [key, value] of Object.entries(
        loadedCampaign.shipping_rate.rates
      )) {
        // console.log(key, value);
        states.push({ reference: key, title: value.title });
      }

      // console.log(states);

      setShippingRate(loadedCampaign.shipping_rate);
      setShippingStates(states);
      setCustomerPool(loadedCampaign.customer_pool);
    }
  }, [loadedCampaign]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/campaigns/${campaign}/init.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setLoadedCampaign(result.data.data.campaign);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    if (campaign !== null) {
      fetchData();
    }
  }, [campaign]);

  useEffect(() => {
    setSelectedShippingStateOption(null);
    if (selectedShippingState === null) {
      return;
    }
    setShippingStateOptions(shippingRate.rates[selectedShippingState].options);
  }, [selectedShippingState]);

  useEffect(() => {
    setCampaignProductVariants([]);
    setSelectCampaignProductVariants([]);
    setProductImages([]);
    setProductImageSize(0);
    if (selectedCampaignProducts.length <= 0) {
      if (campaign === null) {
        return;
      }

      let account = null;
      campaigns.every((param) => {
        if (param.reference === campaign) {
          account = param.account;
        }
        return true;
      });

      setSeverity("error");
      setErrMsg(
        `Campaign has no active products. Please contact ${account.name}.`
      );
      setOpen(true);
    }
  }, [selectedCampaignProducts]);

  // useEffect(() => {
  //   if (selectCampaignProduct === null) {
  //     return;
  //   }

  //   setSelectedQuantity(1);
  //   setCampaignProductVariants([]);
  //   selectedCampaignProducts.every((prd) => {
  //     if (prd.reference === selectCampaignProduct) {
  //       setCampaignProductVariants(prd.variants);
  //       setProductImages(prd.images);
  //       setProductImageSize(prd.images.length);
  //     }
  //     return true;
  //   });
  // }, [selectCampaignProduct]);

  // useEffect(() => {
  //   const sections = [];
  //   if (dataForm === null) {
  //     return;
  //   }

  //   dataForm.form.form.sections.every(async (param) => {
  //     // console.log(param);
  //     const sect = <FormSectionBuilder section={param} />;
  //     sections.push(sect);
  //     return false;
  //   });
  //   // console.log(sections);
  //   setDataFormSections(sections);
  // }, [dataForm]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/campaigns/list.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            if (result.data.data.campaigns.length <= 0) {
              setCampaignUnavailableDialog(true);
            } else {
              setCampaigns(result.data.data.campaigns);
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }

          appVersionCheck(result.data.version);
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  function preprocessDataForm() {
    /* eslint-disable no-restricted-syntax */
    const dForm = document.querySelector(`#dataForm`);
    const data = new FormData(dForm);
    const values = Object.fromEntries(data.entries());

    let exludedName = "";
    let excluded = false;

    dataForm.form.form.sections.every((section) => {
      const ex = section.fields.every((field) => {
        if (!field.is_optional) {
          if (
            !data.has(field.reference) ||
            values[field.reference].length <= 0
          ) {
            excluded = true;
            exludedName = `${field.display_name} (${section.title})`;
            return false;
          }
        }
        return true;
      });

      return ex;
    });

    if (excluded === true) {
      setSeverity("error");
      setErrMsg(`${exludedName} is not provided.`);
      setOpen(true);
      return false;
    }

    return values;
  }

  async function dispense() {
    const gpsCoords = getGPSCoords();
    // console.log(gpsCoords);
    if (!gpsCoords) {
      setSeverity("error");
      setErrMsg("Please enable and allow browser's location and GPS access.");
      setOpen(true);
      return;
    }

    if (checkoutProducts.length <= 0) {
      setSeverity("error");
      setErrMsg("Please select a product.");
      setOpen(true);
      return;
    }

    // if (campaignProductVariants.length > 0) {
    //   if (campaignProductVariants.length !== selectCampaignProductVariants.length) {
    //     setErrMsg("All product option(s) are required.");
    //     setSeverity("error");
    //     setOpen(true);
    //     return;
    //   }
    // }

    // if (parseInt(selectedQuantity, 10) <= 0) {
    //   setErrMsg("Product quantity is required");
    //   setSeverity("error");
    //   setOpen(true);
    //   return;
    // }

    let dataFormValues = {};
    if (dataForm !== null) {
      const values = preprocessDataForm();
      if (values === false) {
        return;
      }
      dataFormValues = {
        reference: dataForm.reference,
        data: values,
      };
    }
    // console.log(dataFormValues);

    if (shippingRequired) {
      if (shippingRecipientName === null || shippingRecipientName.length < 3) {
        setSeverity("error");
        setErrMsg("Shipping receiver's name required");
        setOpen(true);
        return;
      }

      if (
        shippingRecipientPhoneNumber === null ||
        shippingRecipientPhoneNumber.length < 3
      ) {
        setSeverity("error");
        setErrMsg("Shipping receiver's phone number required");
        setOpen(true);
        return;
      }

      if (
        shippingAddress === null ||
        shippingLatitude === null ||
        shippingLongitude === null
      ) {
        setSeverity("error");
        setErrMsg("Shipping address required");
        setOpen(true);
        return;
      }

      if (shippingRate === null) {
        if (shippingCity === null || shippingCity.length < 3) {
          setSeverity("error");
          setErrMsg("Shipping city required");
          setOpen(true);
          return;
        }

        if (shippingState === null || shippingState.length < 3) {
          setSeverity("error");
          setErrMsg("Shipping state required");
          setOpen(true);
          return;
        }
      }
    }

    let shippingOption = null;
    if (shippingRate !== null) {
      if (
        selectedShippingState === null ||
        selectedShippingStateOption === null
      ) {
        setSeverity("error");
        setErrMsg("Please select your shipping location");
        setOpen(true);
        return;
      }

      shippingOption = {
        reference: shippingRate.reference,
        state: selectedShippingState,
        option: selectedShippingStateOption,
      };
    }

    if (firstName === null) {
      setSeverity("error");
      setErrMsg("Customer first name required");
      setOpen(true);
      return;
    }

    if (lastName === null) {
      setSeverity("error");
      setErrMsg("Customer last name required");
      setOpen(true);
      return;
    }

    if (emailAddress === null) {
      setSeverity("error");
      setErrMsg("Customer email address required");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Customer phone number required");
      setOpen(true);
      return;
    }

    if (paymentMethod === null) {
      setSeverity("error");
      setErrMsg("Payment method required.");
      setOpen(true);
      return;
    }

    // if (network === null) {
    //   setSeverity("error");
    //   setErrMsg("Customer mobile network required");
    //   setOpen(true);
    //   return;
    // }

    if (window.confirm("Are you sure you want to proceed?") === false) {
      return;
    }

    setShowLoading(true);
    const json = {
      products: checkoutProducts,
      payment_method: paymentMethod,
      customer: {
        first_name: firstName,
        last_name: lastName,
        email_address: emailAddress,
        phone_number: phoneNumber,
        // mobile_network: `${network}`,
      },
      campaign: `${campaign}`,
      latitude: gpsCoords.latitude,
      longitude: gpsCoords.longitude,
      data_form: dataForm !== null ? dataFormValues : null,
      shipping_option: shippingOption,
      shipping_info: {
        name: shippingRecipientName,
        phone_number: shippingRecipientPhoneNumber,
        address: shippingAddress,
        latitude: shippingLatitude,
        longitude: shippingLongitude,
        state: shippingState,
        city: shippingCity,
      },
      customer_pool_key: customerPoolValue,
    };

    // console.log(json);

    await axios
      .post("agents/sell.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSellResult(result.data.data.result);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function confirmPayment(reference) {
    setShowInlineLoading(true);
    await axios
      .get(`agents/sell/${reference}/status.json`)
      .then((result) => {
        setShowInlineLoading(false);
        if (result.data.status === "success") {
          setSellResult(result.data.data.result);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowInlineLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  // async function buildSectionField(field) {
  //   const compModule = await import(`app/data_forms/components/${field.type}`);
  //   const LoadedComponent = compModule.default;
  //   return <LoadedComponent displayName={field.display_name} name={field.code} />;
  // }

  // async function buildSectionFields(section) {
  //   const fields = [];
  //   section.fields.every(async (field) => {
  //     const comp = await buildSectionField(field);
  //     fields.push(comp);
  //     return false;
  //   });

  //   return fields;
  // }

  const goToNextPicture = () => {
    if (productIndex === productImageSize - 1) {
      setActiveStep(0);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const goBackToPicture = () => {
    if (productIndex === 0) {
      setActiveStep(productImageSize - 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  useEffect(() => {
    if (selectedProduct === null) {
      return;
    }

    setActiveStep(0);
    setSelectedQuantity(1);
    setSelectCampaignProductVariants([]);
    setCampaignProductVariants([]);
    selectedCampaignProducts.every((prd) => {
      if (prd.reference === selectedProduct) {
        setSelectedProductObject(prd);
        setCampaignProductVariants(prd.variants);
        setProductImages(prd.images);
        setProductImageSize(prd.images.length);
        setShowProductDialog(true);
      }
      return true;
    });
  }, [selectedProduct]);

  useEffect(() => {
    let tAmt = 0;
    checkoutProducts.every((prd) => {
      tAmt += prd.amount;
      return true;
    });
    setTotalAmount(tAmt);
  }, [JSON.stringify(checkoutProducts)]);

  function addToCart() {
    const tNum = Number(selectedQuantity);
    if (!tNum) {
      setErrMsg("Invalid product quantity");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (parseInt(selectedQuantity, 10) <= 0) {
      setErrMsg("Product quantity is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (selectedProductObject.order_quantity > 0) {
      if (selectedQuantity > selectedProductObject.order_quantity) {
        setErrMsg(
          `Product quantity can not be more than ${selectedProductObject.order_quantity}`
        );
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    let prdtAmt = selectedProductObject.price;
    if (!selectedProductObject.is_price_fixed) {
      if (selectedProductAmount < selectedProductObject.price_minimum / 100) {
        setErrMsg(
          `Amount can not be less than ${currency.symbol}${(
            selectedProductObject.price_minimum / 100
          ).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        );
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (selectedProductObject.price_maximum > 0) {
        if (selectedProductAmount > selectedProductObject.price_maximum / 100) {
          setErrMsg(
            `Amount can not be more than ${currency.symbol}${(
              selectedProductObject.price_maximum / 100
            ).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          );
          setSeverity("error");
          setOpen(true);
          return;
        }
      }

      prdtAmt = selectedProductAmount * 100;
      if (prdtAmt <= 0) {
        setErrMsg("Invalid amount entered.");
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    if (campaignProductVariants.length > 0) {
      if (
        campaignProductVariants.length !== selectCampaignProductVariants.length
      ) {
        setErrMsg("All product option(s) are required.");
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    const productToAdd = {
      reference: selectedProductObject.reference,
      name: selectedProductObject.title,
      quantity: selectedQuantity,
      amount: prdtAmt * selectedQuantity,
      image: productImageSize > 0 ? productImages[0] : null,
      variants: selectCampaignProductVariants,
    };

    if (checkoutProducts.length <= 0) {
      const tChckPrdts = checkoutProducts;
      tChckPrdts.push(productToAdd);
      setCheckoutProducts(tChckPrdts);
      setSelectedProduct(null);
      setSelectedProductObject(null);
      setShowProductDialog(false);

      setErrMsg("Item added successfully");
      setSeverity("success");
      setOpen(true);
      return;
    }

    const tempCheckoutProducts = checkoutProducts;

    // Check if product was been added
    const prdIndexes = [];
    tempCheckoutProducts.every((prd, index) => {
      if (prd.reference === selectedProductObject.reference) {
        prdIndexes.push(index);
      }
      return true;
    });

    // Check variants of the pre-added product
    if (prdIndexes.length > 0) {
      if (selectedProductObject.order_restriction === "SINGLE") {
        setErrMsg("Product is restricted to one per order.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      let same = true;
      for (const val of prdIndexes) {
        const tempCheckoutVariants = tempCheckoutProducts[val].variants;
        // console.log(tempCheckoutVariants);
        // console.log(selectCampaignProductVariants);

        let differs = false;
        for (const pVariant of selectCampaignProductVariants) {
          let inDiffers = false;
          for (const yVariant of tempCheckoutVariants) {
            if (pVariant.reference === yVariant.reference) {
              // console.log(
              //   `${pVariant.reference} | ${pVariant.option} | ${yVariant.option}`
              // );
              if (pVariant.option !== yVariant.option) {
                inDiffers = true;
              }
            }
          }

          if (inDiffers) {
            differs = true;
          }
        }

        if (!differs) {
          tempCheckoutProducts[val].variants = selectCampaignProductVariants;
          tempCheckoutProducts[val].quantity = selectedQuantity;
          tempCheckoutProducts[val].amount =
            selectedProductObject.price * selectedQuantity;
        } else {
          same = false;
        }
      }

      if (!same) {
        tempCheckoutProducts.push(productToAdd);
      }
    } else {
      tempCheckoutProducts.push(productToAdd);
    }

    setCheckoutProducts(tempCheckoutProducts);
    setSelectedProduct(null);
    setSelectedProductObject(null);
    setShowProductDialog(false);

    setErrMsg("Item added successfully");
    setSeverity("success");
    setOpen(true);

    document.getElementById("selectProductsIDTxt").blur();
  }

  function removeFromCart(index) {
    const tempCheckoutProducts = checkoutProducts;
    tempCheckoutProducts.splice(index, 1);
    setCheckoutProducts(tempCheckoutProducts);

    setErrMsg("Item removed");
    setSeverity("success");
    setOpen(true);
  }

  const [
    allowPushNotificationDialogState,
    setAllowPushNotificationDialogState,
  ] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PushNotificationMgr
        displayState={allowPushNotificationDialogState}
        setDisplayState={setAllowPushNotificationDialogState}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {campaignUnavailableDialog ? (
        <Dialog open fullWidth maxWidth="xs">
          <DialogContent>
            <MDBox mt={3} align="center" mb={3}>
              <MDBox>
                <img src={WarningIcon} alt="warning" width={64} />
              </MDBox>
              <MDBox mt={1}>
                <MDTypography variant="h6" fontWeight="light">
                  You have no active campaigns.
                </MDTypography>
              </MDBox>
              <MDBox mt={2}>
                <MDTypography variant="h6" fontWeight="regular">
                  Go to the Product Hub to see available products you can sell
                  and earn from.
                </MDTypography>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              mr={3}
              onClick={() => {
                navigate("/product-hub");
              }}
              color="primary"
              variant="contained"
              startIcon={
                <Icon
                  sx={{ cursor: "pointer" }}
                  fontSize="small"
                  color="primary"
                >
                  chevron_right
                </Icon>
              }
            >
              Product Hub
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      {sellResult && (
        <Dialog open fullWidth maxWidth="sm">
          <DialogContent>
            <Container align="center">
              <MDTypography align="center">
                {sellResult.charge_status === "success" ? (
                  <MDBox>
                    <MDBox mb={2} color="success">
                      <b>Success!</b>
                    </MDBox>
                    <QRCode value={sellResult.order.receipt} size={180} />
                    <MDBox mt={2}>
                      <MDTypography variant="h6" fontWeight="light">
                        {sellResult.order.customer}
                      </MDTypography>
                    </MDBox>
                    {sellResult.order.items.map((orderItem) => (
                      <MDBox mt={1} align="left">
                        <Divider />
                        <MDTypography variant="h6" fontWeight="light">
                          {orderItem.product}
                        </MDTypography>
                        {orderItem.objects.map((object) => (
                          <>
                            {object.map((record) => (
                              <MDBox
                                mt={1}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <MDBox>
                                  <MDTypography
                                    variant="caption"
                                    fontWeight="light"
                                  >
                                    <b>{record.display_name}</b>
                                    <br />
                                    {record.value}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDButton
                                    iconOnly
                                    onClick={() => {
                                      copy(record.value);
                                    }}
                                    color="info"
                                    variant="outlined"
                                    size="small"
                                  >
                                    <Icon>content_copy</Icon>
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            ))}
                          </>
                        ))}
                      </MDBox>
                    ))}
                    <MDBox
                      mt={3}
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      <MDTypography variant="h6" fontWeight="light">
                        [x close]
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                ) : (
                  <MDBox>
                    {sellResult.type === "display" ? (
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="light">
                          {sellResult.caption}
                        </MDTypography>
                        <MDTypography variant="h3" fontWeight="medium">
                          {currency.symbol}
                          {(sellResult.debit_amount / 100).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </MDTypography>
                        <Divider />
                        <MDBox align="center">
                          <MDTypography variant="h6" fontWeight="regular">
                            {sellResult.instructions}
                          </MDTypography>
                        </MDBox>
                        <Divider />
                        <MDBox align="center">
                          {sellResult.instrument.map((record) => (
                            <Grid container spacing={3}>
                              <Grid item xs={6} md={6} lg={6}>
                                <MDBox align="left">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <b>{record.key}:</b>
                                  </MDTypography>
                                </MDBox>
                              </Grid>
                              <Grid item xs={6} md={6} lg={6}>
                                <MDBox align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {record.value}
                                  </MDTypography>
                                </MDBox>
                              </Grid>
                            </Grid>
                          ))}
                        </MDBox>
                        <Divider />
                        <MDBox align="center">
                          <MDTypography variant="h6" fontWeight="bold">
                            {sellResult.notes}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    ) : (
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="light">
                          {sellResult.caption}
                        </MDTypography>
                        <MDTypography variant="h3" fontWeight="medium">
                          {currency.symbol}
                          {(sellResult.debit_amount / 100).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </MDTypography>
                        <Divider />
                        <QRCode
                          value={
                            sellResult.instrument.redirect_url != null
                              ? sellResult.instrument.redirect_url
                              : ""
                          }
                          size={180}
                        />
                        <MDBox mt={3}>
                          <MDButton
                            onClick={() => {
                              copy(sellResult.instrument.redirect_url);
                            }}
                            color="success"
                            variant="contained"
                            size="small"
                          >
                            <Icon>content_copy</Icon> &nbsp; Copy
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    )}
                    <Divider mt={3} />
                    <MDBox mt={5}>
                      <MDButton
                        color="success"
                        variant="outlined"
                        sx={{ width: "100%" }}
                        onClick={() => {
                          confirmPayment(sellResult.reference);
                        }}
                      >
                        Confirm Payment
                      </MDButton>
                      {showInlineLoading ? (
                        <MDBox mt={3}>
                          <LinearProgress color="info" />
                        </MDBox>
                      ) : (
                        <> </>
                      )}
                      <MDBox
                        mt={3}
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to close?"
                            ) === true
                          ) {
                            window.location.reload();
                          }
                        }}
                      >
                        <MDTypography variant="h6" fontWeight="light">
                          [ x close ]
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                )}

                <Snackbar
                  autoHideDuration={5000}
                  onClose={() => setOpenSnackBar(false)}
                  open={openCopySnackBar}
                >
                  <Alert severity="success" sx={{ width: "100%" }}>
                    Copied
                  </Alert>
                </Snackbar>
              </MDTypography>
            </Container>
          </DialogContent>
        </Dialog>
      )}
      {selectedProductObject !== null && (
        <Dialog open={showProductDialog} fullWidth maxWidth="md">
          <DialogTitle>
            <MDBox mt={2} align="center">
              <MDTypography>
                {selectedProductObject.title}
                {selectedProductObject.is_price_fixed ? (
                  <span>
                    <br />
                    {currency.symbol}
                    {(selectedProductObject.price / 100).toLocaleString("en", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                ) : (
                  <> </>
                )}
              </MDTypography>
            </MDBox>
          </DialogTitle>
          <MDBox mt={-1} mb={0}>
            <Divider />
          </MDBox>
          <DialogContent>
            <MDBox mb={3}>
              <MDBox elevation={3}>
                <MDBox p={0}>
                  <MDBox mt={1}>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                          // display: {
                          //   xs: "flex",
                          //   sm: "flex",
                          //   md: "flex",
                          // },
                          // flexDirection: "column",
                          // backgroundColor: "background.paper",
                          // borderRight: { sm: "none", md: "1px solid" },
                          // borderColor: { sm: "none", md: "divider" },
                          // alignItems: "start",
                          pt: { xs: -4, md: 4 },
                          px: { xs: 1, sm: 3 },
                          gap: { xs: 0, md: 4 },
                        }}
                      >
                        <MDBox p={0} align="center">
                          <MDBox align="center">
                            <img
                              src={`${AppConfig.api_media_url}${productImages[productIndex]}`}
                              alt="img"
                              // width="35%"
                              // maxWidth="100px"
                              height="150vh"
                            />
                          </MDBox>
                          {productImageSize > 1 ? (
                            <MDBox mt={2}>
                              <Grid container spacing={3}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <MDBox align="left">
                                    <MDButton
                                      onClick={goBackToPicture}
                                      variant="outlined"
                                      iconOnly
                                      color="dark"
                                      size="small"
                                    >
                                      <Icon>keyboard_arrow_left</Icon>
                                    </MDButton>
                                  </MDBox>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <MDBox align="right">
                                    <MDButton
                                      variant="outlined"
                                      onClick={goToNextPicture}
                                      iconOnly
                                      color="dark"
                                      size="small"
                                    >
                                      <Icon>keyboard_arrow_right</Icon>
                                    </MDButton>
                                  </MDBox>
                                </Grid>
                              </Grid>
                            </MDBox>
                          ) : (
                            <> </>
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <MDBox px={1}>
                          <MDBox>
                            {!selectedProductObject.is_price_fixed ? (
                              <MDBox mt={3} mb={3}>
                                <MDBox px={0}>
                                  <MDTypography
                                    variant="caption"
                                    fontWeight="regular"
                                  >
                                    ENTER AMOUNT
                                  </MDTypography>
                                </MDBox>
                                <MDBox mt={3}>
                                  <TextField
                                    sx={{
                                      size: {
                                        xs: "small",
                                        md: "large",
                                        lg: "large",
                                      },
                                    }}
                                    // value={selectedProductAmount}
                                    type="decimal"
                                    label="Amount"
                                    fullWidth
                                    onChange={(e) =>
                                      setSelectedProductAmount(
                                        parseFloat(e.target.value, 10)
                                      )
                                    }
                                  />
                                </MDBox>
                              </MDBox>
                            ) : (
                              <> </>
                            )}
                            {campaignProductVariants.length > 0 ? (
                              <MDBox mt={0}>
                                <MDBox px={0}>
                                  <MDTypography
                                    variant="caption"
                                    fontWeight="regular"
                                  >
                                    PRODUCT OPTIONS
                                  </MDTypography>
                                </MDBox>
                                <MDBox mt={2}>
                                  <Grid container spacing={{ xs: 3, md: 2 }}>
                                    {campaignProductVariants.map((variant) => (
                                      <Grid item xs={12} md={6} lg={6}>
                                        <FormControl
                                          sx={{ minWidth: 120, width: "100%" }}
                                        >
                                          <InputLabel>{`${variant.title}`}</InputLabel>
                                          <Select
                                            label={`${variant.title}`}
                                            sx={{
                                              padding: "12px",
                                              paddingLeft: "3px",
                                            }}
                                            onChange={(e) => {
                                              let optName = "";
                                              campaignProductVariants.every(
                                                (v) => {
                                                  if (
                                                    v.reference ===
                                                    variant.reference
                                                  ) {
                                                    v.options.every((o) => {
                                                      if (
                                                        o.reference ===
                                                        e.target.value
                                                      ) {
                                                        optName = o.title;
                                                      }
                                                      return true;
                                                    });
                                                  }
                                                  return true;
                                                }
                                              );
                                              const temVariants =
                                                selectCampaignProductVariants;
                                              if (temVariants.length === 0) {
                                                const obj = {
                                                  reference: variant.reference,
                                                  variant_title: variant.title,
                                                  option: e.target.value,
                                                  option_title: optName,
                                                };
                                                temVariants.push(obj);
                                                setSelectCampaignProductVariants(
                                                  temVariants
                                                );
                                                return;
                                              }

                                              let exists = null;
                                              for (const [
                                                index,
                                                row,
                                              ] of temVariants.entries()) {
                                                if (
                                                  row.reference ===
                                                  variant.reference
                                                ) {
                                                  exists = index;
                                                  break;
                                                }
                                              }

                                              if (exists !== null) {
                                                temVariants[exists].option =
                                                  e.target.value;
                                                temVariants[
                                                  exists
                                                ].option_title = optName;
                                              } else {
                                                const obj = {
                                                  reference: variant.reference,
                                                  variant_title: variant.title,
                                                  option: e.target.value,
                                                  option_title: optName,
                                                };
                                                temVariants.push(obj);
                                              }
                                              // console.log(temVariants);
                                              setSelectCampaignProductVariants(
                                                temVariants
                                              );
                                            }}
                                          >
                                            {variant.options.length > 0 &&
                                              variant.options.map((opt) => (
                                                <MenuItem
                                                  name={opt.title}
                                                  // key={`${opt.reference}_${idx}`}
                                                  value={opt.reference}
                                                >
                                                  {opt.title}
                                                </MenuItem>
                                              ))}
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                    ))}
                                  </Grid>
                                </MDBox>
                                <MDBox mt={3} mb={3}>
                                  <Divider />
                                </MDBox>
                              </MDBox>
                            ) : (
                              <> </>
                            )}
                          </MDBox>
                          {selectedProductObject.order_restriction ===
                          "MULTIPLE" ? (
                            <MDBox mt={3}>
                              <MDBox px={0}>
                                <MDTypography
                                  variant="caption"
                                  fontWeight="regular"
                                >
                                  PRODUCT QUANTITY
                                </MDTypography>
                              </MDBox>
                              <MDBox mt={3}>
                                <TextField
                                  sx={{
                                    size: {
                                      xs: "small",
                                      md: "large",
                                      lg: "large",
                                    },
                                  }}
                                  value={selectedQuantity}
                                  type="number"
                                  label="Quantity"
                                  fullWidth
                                  onChange={(e) =>
                                    setSelectedQuantity(
                                      parseInt(e.target.value, 10)
                                    )
                                  }
                                />
                              </MDBox>
                            </MDBox>
                          ) : (
                            <> </>
                          )}
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
            {selectedProductObject.description && (
              <MDBox mt={1}>
                <MDBox mt={1}>
                  <Divider />
                </MDBox>
                <MDBox mt={2}>
                  <MDTypography variant="caption" fontWeight="regular">
                    DESCRIPTION
                  </MDTypography>
                </MDBox>
                <MDBox mt={1}>
                  <MDTypography variant="text" fontWeight="light" fontSize={12}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: selectedProductObject.description,
                      }}
                    />
                  </MDTypography>
                </MDBox>
                <MDBox mt={3}>
                  <Divider />
                </MDBox>
              </MDBox>
            )}
          </DialogContent>
          <DialogActions>
            <MDBox p={1}>
              <MDButton
                variant="outlined"
                color="dark"
                startIcon={<Icon>cancel_outline</Icon>}
                onClick={() => {
                  setSelectedProduct(null);
                  setSelectedProductObject(null);
                  setShowProductDialog(false);
                }}
              >
                Cancel
              </MDButton>
              &nbsp;&nbsp;
              <MDButton
                variant="contained"
                color="dark"
                startIcon={<Icon>add</Icon>}
                onClick={() => {
                  addToCart();
                }}
              >
                Add
              </MDButton>
            </MDBox>
          </DialogActions>
        </Dialog>
      )}
      <MDBox>
        <MDBox pt={3} pb={3}>
          <Grid
            container
            spacing={3}
            display="flex"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Grid item xs={12} md={7} lg={7}>
              <MDBox>
                <MDBox mb={3}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium">
                        Sell Product(s)
                      </MDTypography>
                      <MDBox mt={2}>
                        <MDBox mb={1}>
                          <MDTypography variant="caption" fontWeight="regular">
                            ORDER
                          </MDTypography>
                        </MDBox>
                        <MDBox pt={2}>
                          {/* <MDBox>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Select Campaign</InputLabel>
                              <Select
                                label="Select Campaign"
                                onChange={(e) => {
                                  setCampaign(e.target.value);
                                }}
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                {
                                  // --> Notice below changes
                                  campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    campaigns.map((record) => (
                                      <MenuItem value={record.reference}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="regular"
                                          fontSize={14}
                                        >
                                          <img
                                            src={`${AppConfig.api_media_url}${record.account.icon}`}
                                            alt=""
                                            width="14px"
                                          />
                                          &nbsp;&nbsp;{record.account.name} | {record.title}
                                        </MDTypography>
                                      </MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                          </MDBox> */}
                          <MDBox mb={3}>
                            <Autocomplete
                              // value={campaign}
                              disablePortal
                              id="selectCampaignID"
                              fullWidth
                              options={campaigns}
                              getOptionLabel={(option) =>
                                `${option.account.name} | ${option.title}`
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  id="selectCampaignIDTxt"
                                  label="Select Campaign"
                                />
                              )}
                              renderOption={(props, record) => (
                                <div
                                  {...props}
                                  key={record.reference}
                                  value={record.reference}
                                >
                                  <MDTypography
                                    variant="h6"
                                    fontWeight="regular"
                                    fontSize={14}
                                  >
                                    <img
                                      src={`${AppConfig.api_media_url}${record.account.icon}`}
                                      alt=""
                                      width="14px"
                                    />
                                    &nbsp;&nbsp;{record.account.name} |{" "}
                                    {record.title}
                                  </MDTypography>
                                </div>
                              )}
                              // getOptionKey={(option) => option.reference}
                              onChange={(event, value) => {
                                setCampaign(value.reference);
                              }}
                            />
                          </MDBox>
                          {/* <MDBox mt={4} mb={1}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Select Product</InputLabel>
                              <Select
                                label="Select Product"
                                onChange={(e) => {
                                  setSelectCampaignProduct(e.target.value);
                                }}
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                {
                                  // --> Notice below changes
                                  selectedCampaignProducts.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    selectedCampaignProducts.map((record) => (
                                      <MenuItem value={record.reference}>
                                        <span>
                                          {record.title}
                                          <br />
                                          {currency.symbol}
                                          {(record.price / 100).toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </span>
                                      </MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                          </MDBox> */}
                          <MDBox mt={4} mb={1}>
                            <MDBox mb={3}>
                              <Autocomplete
                                value={selectedProductObject}
                                disablePortal
                                id="selectProductsID"
                                fullWidth
                                options={selectedCampaignProducts}
                                // options={products}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    id="selectProductsIDTxt"
                                    label="Select product(s)"
                                  />
                                )}
                                renderOption={(props, record) => (
                                  <div
                                    {...props}
                                    key={record.reference}
                                    value={record.reference}
                                  >
                                    <MDTypography
                                      variant="caption"
                                      noWrap
                                      fontWeight="regular"
                                      fontSize={14}
                                    >
                                      {record.title}
                                      <br />
                                      {record.is_price_fixed ? (
                                        <span>
                                          <b>
                                            {currency.symbol}
                                            {(
                                              record.price / 100
                                            ).toLocaleString("en", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </b>
                                        </span>
                                      ) : (
                                        <> &nbsp; </>
                                      )}
                                    </MDTypography>
                                  </div>
                                )}
                                // getOptionKey={(option) => option.reference}
                                onChange={(event, value) => {
                                  setSelectedProduct(value.reference);
                                }}
                              />
                            </MDBox>
                            {checkoutProducts.length > 0 ? (
                              <MDBox mt={3} mb={3}>
                                {/* <MDBox mt={3} mb={3}>
                                  <Divider />
                                </MDBox> */}
                                <MDBox>
                                  <MDTypography
                                    variant="caption"
                                    fontWeight="regular"
                                  >
                                    ORDER ITEMS
                                  </MDTypography>
                                </MDBox>
                                <MDBox px={1}>
                                  <List disablePadding>
                                    {checkoutProducts.map((product, index) => (
                                      <ListItem
                                        key={product.reference}
                                        sx={{ py: 1, px: 0 }}
                                      >
                                        <ListItemIcon>
                                          <img
                                            src={`${AppConfig.api_media_url}${product.image}`}
                                            // alt={product.name}
                                            alt="-"
                                            width="36px"
                                          />
                                        </ListItemIcon>
                                        <ListItemText
                                          sx={{ mr: 2 }}
                                          primary={
                                            <MDTypography
                                              variant="subtitle2"
                                              fontWeight="regular"
                                              fontSize={12}
                                            >
                                              {product.name}
                                            </MDTypography>
                                          }
                                          secondary={
                                            <MDBox mt={1}>
                                              <MDTypography
                                                fontSize={10}
                                                variant="h6"
                                                fontWeight="regular"
                                              >
                                                {product.variants.map(
                                                  (variant) => (
                                                    <>
                                                      {variant.variant_title}
                                                      :&nbsp;
                                                      {variant.option_title}
                                                      &nbsp;|&nbsp;
                                                    </>
                                                  )
                                                )}
                                                {`Quantity: ${product.quantity}`}
                                              </MDTypography>
                                            </MDBox>
                                          }
                                        />
                                        <MDBox>
                                          <MDBox mt={0}>
                                            <MDTypography
                                              variant="h6"
                                              fontWeight="regular"
                                              fontSize={14}
                                            >
                                              <small>{currency.symbol}</small>
                                              {(
                                                product.amount / 100
                                              ).toLocaleString("en", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </MDTypography>
                                          </MDBox>
                                          <MDBox mt={0} align="right">
                                            <MDButton
                                              variant="outlined"
                                              iconOnly
                                              onClick={() => {
                                                if (
                                                  window.confirm(
                                                    "Remove item?"
                                                  ) === true
                                                ) {
                                                  removeFromCart(index);
                                                }
                                              }}
                                            >
                                              <Icon color="error">cancel</Icon>
                                            </MDButton>
                                          </MDBox>
                                        </MDBox>
                                      </ListItem>
                                    ))}
                                  </List>
                                </MDBox>
                                <MDBox mt={2}>
                                  <Divider />
                                </MDBox>
                                <MDBox mt={3} align="right">
                                  <MDTypography variant="h6" fontSize={18}>
                                    <small>TOTAL:</small>{" "}
                                    <small>{currency.symbol}</small>
                                    {(totalAmount / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            ) : (
                              <> </>
                            )}
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>

                {/* {dataForm !== null && (
                  // <form id={dataForm.reference}>
                  <form id="dataForm">
                    {dataFormSections.map((section) => (
                      <MDBox mb={3}>
                        <Card sx={{ height: "100%", marginTop: "0px" }}>{section}</Card>
                      </MDBox>
                    ))}
                  </form>
                )} */}

                {dataForm !== null && (
                  <form id="dataForm">
                    {dataForm.form.form.sections.map((formSection) => {
                      let sect = (
                        <MDBox mb={3}>
                          <Card sx={{ height: "100%", marginTop: "0px" }}>
                            <FormSectionBuilder
                              section={formSection}
                              logic={dataForm.form.form.navigation_logic}
                            />
                          </Card>
                        </MDBox>
                      );
                      if (
                        formSection.reference in
                        dataForm.form.form.navigation_logic.listeners
                      ) {
                        const listener =
                          dataForm.form.form.navigation_logic.listeners[
                            formSection.reference
                          ];
                        const parentField = document.getElementById(
                          `dff_${listener.trigger}`
                        );
                        if (parentField !== null) {
                          let wID = `t_watcher_${listener.type}_${formSection.reference}`;
                          sect = (
                            <div id={`${wID}`} style={{ display: "none" }}>
                              {sect}
                            </div>
                          );
                          parentField.addEventListener("change", function () {
                            const d = document.getElementById(wID);
                            if (parentField.value !== listener.control) {
                              d.style.display = "none";
                              formSection.fields.every((fld) => {
                                document.getElementById(
                                  `dff_${fld.reference}`
                                ).value = null;
                                return false;
                              });
                            } else {
                              d.style.display = "block";
                            }
                          });
                        }
                      }
                      return sect;
                    })}
                  </form>
                )}

                {shippingRequired && (
                  <MDBox mb={3}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={3}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          textTransform="capitalize"
                          mb={3}
                        >
                          Shipping Information
                        </MDTypography>
                        <MDBox mb={2}>
                          <MDInput
                            name="recipient_name"
                            margin="dense"
                            label="Receiver's Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) =>
                              setShippingRecipientName(e.target.value)
                            }
                          />
                        </MDBox>
                        <MDBox mb={2}>
                          <MDInput
                            name="phone_number"
                            margin="dense"
                            label="Receiver's Phone Number"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) =>
                              setShippingRecipientPhoneNumber(e.target.value)
                            }
                          />
                        </MDBox>
                        <MDBox mb={2}>
                          <GoogleAddressField
                            displayName="Receiver's Address"
                            setAddress={setShippingAddress}
                            setLatitude={setShippingLatitude}
                            setLongitude={setShippingLongitude}
                          />
                        </MDBox>
                        {shippingRate === null ? (
                          <>
                            <MDBox mb={2}>
                              <MDInput
                                name="shipping_city"
                                margin="dense"
                                label="Shipping City"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) =>
                                  setShippingCity(e.target.value)
                                }
                              />
                            </MDBox>
                            <MDBox mb={2}>
                              <MDInput
                                name="shipping_state"
                                margin="dense"
                                label="Shipping State"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) =>
                                  setShippingState(e.target.value)
                                }
                              />
                            </MDBox>
                          </>
                        ) : (
                          <> </>
                        )}
                      </MDBox>
                    </Card>
                  </MDBox>
                )}

                {shippingRate !== null && (
                  <MDBox mt={5} mb={5}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox px={3} py={3}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          textTransform="capitalize"
                          mb={0}
                        >
                          Shipping Options
                        </MDTypography>
                        <MDBox mt={1} mb={2}>
                          <MDBox mt={1} mb={3}>
                            <MDBox mt={3}>
                              <FormControl
                                sx={{ minWidth: 120, width: "100%" }}
                              >
                                <InputLabel>Select State</InputLabel>
                                <Select
                                  value={selectedShippingState}
                                  label="Select State"
                                  onChange={(e) => {
                                    setSelectedShippingState(e.target.value);
                                  }}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    shippingStates.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      shippingStates.map((record) => (
                                        <MenuItem
                                          key={record.reference}
                                          value={record.reference}
                                        >
                                          {record.title}
                                        </MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </MDBox>
                            <MDBox mt={4}>
                              <FormControl
                                sx={{ minWidth: 120, width: "100%" }}
                              >
                                <InputLabel>Select Location</InputLabel>
                                <Select
                                  value={selectedShippingStateOption}
                                  label="Select Location"
                                  onChange={(e) => {
                                    setSelectedShippingStateOption(
                                      e.target.value
                                    );
                                  }}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    shippingStateOptions.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      shippingStateOptions.map((record) => (
                                        <MenuItem
                                          key={record.reference}
                                          value={record.reference}
                                        >
                                          <MDTypography
                                            variant="caption"
                                            fontWeight={500}
                                            fontSize={14}
                                          >
                                            {record.title}
                                            <br />
                                            <b>
                                              Shipping Fee:&nbsp;
                                              {currency.symbol}
                                              {(
                                                record.amount / 100
                                              ).toLocaleString("en", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </b>
                                          </MDTypography>
                                        </MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                )}

                <MDBox mb={3}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        textTransform="capitalize"
                        mb={3}
                      >
                        Customer Information
                      </MDTypography>
                      {customerPool !== null && (
                        <MDBox mb={2}>
                          <MDInput
                            name={customerPool.reference}
                            margin="dense"
                            label={customerPool.customer_identifier}
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) =>
                              setCustomerPoolValue(e.target.value)
                            }
                          />
                        </MDBox>
                      )}
                      <MDBox mb={2}>
                        <MDInput
                          name="last_name"
                          margin="dense"
                          label="Last Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mb={2}>
                        <MDInput
                          name="first_name"
                          margin="dense"
                          label="First Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mb={2}>
                        <MDInput
                          name="email_address"
                          margin="dense"
                          label="Email Address"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setEmailAddress(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mb={2}>
                        <MDInput
                          name="phone_number"
                          margin="dense"
                          label="Phone Number"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </MDBox>
                      {/* <MDBox mt={3}>
                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                          <InputLabel>Customer Mobile Network</InputLabel>
                          <Select
                            label="Customer Mobile Network"
                            onChange={(e) => {
                              setNetwork(e.target.value);
                            }}
                            sx={{ padding: "12px", paddingLeft: "3px" }}
                          >
                            <MenuItem value="MTN">MTN</MenuItem>
                            <MenuItem value="GLO">GLO</MenuItem>
                            <MenuItem value="9MOBILE">9Mobile</MenuItem>
                            <MenuItem value="AIRTEL">Airtel</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox> */}
                    </MDBox>
                  </Card>
                </MDBox>

                {showPaymentMethods && (
                  <MDBox mb={3}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={3}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          textTransform="capitalize"
                          mb={3}
                        >
                          Payment Method
                        </MDTypography>
                        <MDBox mt={1} mb={1}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>
                              Customer&lsquo;s Payment Method
                            </InputLabel>
                            <Select
                              label="Customer's Payment Method"
                              onChange={(e) => {
                                setPaymentMethod(e.target.value);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              {
                                // --> Notice below changes
                                campaignPaymentMethods.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  campaignPaymentMethods.map((record) => (
                                    <MenuItem value={record}>{record}</MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                )}
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox mt={1} p={3}>
                    <MDButton
                      color="primary"
                      variant="contained"
                      sx={{ width: "100%" }}
                      onClick={() => {
                        dispense();
                      }}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SellProduct;
